<template>
  <div class="contact-us-con pl-lg-5">
    <h3>Contact us</h3>
    <ul class="mt-2">
      <template v-for="(contactUsMenu, idx) in contactUsMenuItems">
        <li v-if="contactUsMenu.enabled" :key="idx" class="">
          <b-link
            :href="contactUsMenu.value"
            :ref="contactUsMenu.name"
            :target="contactUsMenu.target"
            class="text-muted"
            v-html="contactUsMenu.name"
          >
          </b-link>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  mounted() {
    axios
      .get(
        process.env.VUE_APP_CORE_URL +
          '/api/get-menu/' +
          'cr-footer-menu',
      )
      .then((response) => {
        this.contactUsMenuItems = response.data;
      });
  },

  data() {
    return {
      contactUsMenuItems: [
        {
          name: '',
          value: '',
          target: '',
          enabled: '',
        },
      ],
    };
  },
};
</script>
